import { Avatar, Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { BrowsedJobDetailsContainerStyled } from '../TechnicianBrowsedJobDetails/style';

const ClientInformation = ({clientId,email}:{email:String,clientId:string}) => {
  return (
    <BrowsedJobDetailsContainerStyled>
      <Typography
        variant="normal"
        fontColor="secondary"
        className="section-title"
        strong
      >
        CLIENT INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        {/* <InfoRowStyled className="jobInformation">
          <Typography className="title" fontColor="dark">
            Client Name :
          </Typography>
          <Avatar size="sm" src={''} />
          <Typography fontColor="dark" className="value">
            Sachin Bhattarai
          </Typography>
        </InfoRowStyled> */}
        <InfoRowStyled className="jobInformation">
          <Typography className="title" fontColor="dark">
            Email Address :
          </Typography>
          <Typography className="value">
           {email}
          </Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </BrowsedJobDetailsContainerStyled>
  );
};

export default ClientInformation;
